import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="payment-element"
export default class extends Controller {
  static values = { new: Boolean };

  static targets = ['form', 'item', 'delete', 'deleteConfirm'];

  connect() {
    document.addEventListener('contact-details:showDelete', () => { this.toggle(); });
    document.addEventListener('contact-details:showEditContactDetail', () => { this.toggle(); });
  }

  toggle() {
    if (!this.newValue) {
      this.cancelEdit();

      if (this.hasDeleteConfirmTarget) {
        this.cancelDeleteConfirm();
      }
    }
  }

  showEditContactDetailForm() {
    this.dispatch('showEditContactDetail');
    this.itemTarget.classList.add('d-none');
    this.formTarget.classList.remove('d-none');
  }

  cancelEdit() {
    this.itemTarget.classList.remove('d-none');
    this.formTarget.classList.add('d-none');
  }

  showDeleteConfirm() {
    this.dispatch('showDelete');
    this.deleteConfirmTarget.classList.remove('d-none');
    this.deleteTarget.classList.add('d-none');
    this.element.classList.add('bg-warning');
  }

  cancelDeleteConfirm() {
    this.deleteConfirmTarget.classList.add('d-none');
    this.deleteTarget.classList.remove('d-none');
    this.element.classList.remove('bg-warning');
  }
}
